import React from 'react';
import './Subtotal.css';
import CurrencyFormat from 'react-currency-format';
import { useHistory } from 'react-router-dom';

function Subtotal(props) {
  const history = useHistory();
  return (
    <div className="subtotal">
      <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              Subtotal({props.count} ):<strong>{value + ' Item'}</strong>
            </p>

            <small className="subtotal_gift">
              <input type="checkbox" /> this Order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value={props.Total} // homework
        displayType={'text'}
        thousandSeperator={true}
        prefix="$"
      />
      <button className="subtotal-button" onClick={e=>history.push("/paymentPage")}>proceed to checkout</button>
    </div>
  );
}

export default Subtotal;
